module.exports = __webpack_public_path__ + "img/product20.33452627.png";